import { mode } from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    brand: {
      100: "#E9E3FF",
      200: "#422AFB",
      300: "#422AFB",
      400: "#7551FF",
      500: "#9B0014", //unipd red
      600: "#3311DB",
      700: "#02044A",
      800: "#190793",
      900: "#11047A",
    },
  },
};
